//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

export const InstagramMetrics = () => {
  return (
    <div>Instagram Metrics</div> // TODO: PD-270510 - add summary section
  );
};
